/**
 * useFollowing Hook (Web)
 * Thin wrapper around shared useFollowing
 */

import { useAuth } from '@contexts/AuthContext';
import { createHttpClient } from '@parlay-picker/shared/api/httpClient';
import {
  type UseFollowingResult,
  useFollowing as useFollowingShared,
} from '@parlay-picker/shared/hooks';
import { useMemo } from 'react';
import { API_BASE_URL } from '../config/api';

export type { UseFollowingResult };

export function useFollowing(displayName: string | undefined): UseFollowingResult {
  const { authFetch } = useAuth();

  const httpClient = useMemo(
    () => createHttpClient({ authFetch, baseUrl: API_BASE_URL }),
    [authFetch],
  );

  return useFollowingShared({ httpClient, displayName });
}
